export type BannerTone = 'training' | 'staging'

export interface InstanceBannerValue {
  text: string
  tone: BannerTone | null
}

/** What the bar says when an admin turns it on without writing their own text. */
export const DEFAULT_BANNER_TEXT: Record<BannerTone, string> = {
  training: 'Training — changes here never reach the website',
  staging: 'Staging — changes here are not live',
}
